import React from 'react';
import PropTypes from 'prop-types';

const AreaHeader = ({ name }) => (
  <div className="col-sm-12">
    <div className="header" style={{marginLeft: 15}}>
      <h3 style={{fontSize: 22}}>{name}</h3>
    </div>
  </div>
);

AreaHeader.propTypes = {
  name: PropTypes.string.isRequired,
};

export default AreaHeader;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/AreaHeader.js